import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const VideoCall = ({userId}) => {
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    fetch(`/api/users/${userId}.json`)
      .then(response => response.json())
      .then(data => setUserProfile(data))
      .catch(error => console.error("Error loading user profile:", error));
  }, [userId]);

  if (!userProfile) return <div>Loading profile...</div>;

  return (
    <div className="profile-container">
      <img src={userProfile.coverPhoto} alt="Cover" className="cover-photo" />
      <img src={userProfile.profilePicture} alt="Profile" className="profile-pic" />
      <h1>{userProfile.username}</h1>
      <p>{userProfile.bio}</p>
      <p>Followers: {userProfile.followersCount}</p>
      <p>Following: {userProfile.followingCount}</p>
      {/* Render posts */}
    </div>
  );
};

export default VideoCall;
